import { AppointmentInvalidTransitionFault } from '@dreryk/egabinet-appointment-frontend-api';
import { VisitCancelCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarNegativeEvent, dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { prescriptionVisitsTranslationKeys, visitTranslationKeys } from '../../../../translations';

type PrescriptionVisitCancelCommandParameters = {
   visitId: number;
};

type PrescriptionVisitCancelCommandOptions = {
   onSuccess: VoidFunction;
   onFault: VoidFunction;
};

export const usePrescriptionVisitCancelCommand = (
   options: PrescriptionVisitCancelCommandOptions
): UseCqrsCommandResult<void, PrescriptionVisitCancelCommandParameters, AppointmentInvalidTransitionFault> => {
   return useCqrsCommand(
      (parameters) => {
         const command = new VisitCancelCommand();
         command.id = parameters.visitId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(prescriptionVisitsTranslationKeys.successfullyCancelledVisit);
            options.onSuccess();
         },
         onFault: {
            'egabinet-appointment-frontend-api:AppointmentInvalidTransitionFault': () => {
               dispatchSnackbarNegativeEvent(visitTranslationKeys.alreadyCancelled);
               options.onFault();
            },
         },
      }
   );
};
